import React from 'react';

export default function Logo({ size = 'medium', showTagline = true }) {
  const sizes = {
    small: { icon: 32, text: 16, tagline: 10 },
    medium: { icon: 48, text: 24, tagline: 12 },
    large: { icon: 64, text: 32, tagline: 14 }
  };

  const s = sizes[size];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {/* Cute Otter Icon */}
      <svg width={s.icon} height={s.icon} viewBox="0 0 100 100" fill="none">
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#81c784" />
            <stop offset="100%" stopColor="#64b5f6" />
          </linearGradient>
        </defs>
        
        {/* Otter Body */}
        <ellipse cx="50" cy="60" rx="28" ry="32" fill="url(#logoGradient)" />
        
        {/* Otter Head */}
        <circle cx="50" cy="35" r="22" fill="url(#logoGradient)" />
        
        {/* Belly (lighter) */}
        <ellipse cx="50" cy="60" rx="18" ry="24" fill="white" opacity="0.3" />
        <ellipse cx="50" cy="35" rx="14" ry="16" fill="white" opacity="0.3" />
        
        {/* Ears */}
        <circle cx="38" cy="22" r="6" fill="url(#logoGradient)" />
        <circle cx="62" cy="22" r="6" fill="url(#logoGradient)" />
        
        {/* Eyes (cute and sparkly) */}
        <circle cx="43" cy="33" r="4" fill="#2c3e50" />
        <circle cx="57" cy="33" r="4" fill="#2c3e50" />
        <circle cx="44" cy="32" r="1.5" fill="white" />
        <circle cx="58" cy="32" r="1.5" fill="white" />
        
        {/* Nose */}
        <ellipse cx="50" cy="40" rx="3" ry="2.5" fill="#424242" />
        
        {/* Whiskers */}
        <line x1="35" y1="38" x2="25" y2="37" stroke="#424242" strokeWidth="1" opacity="0.6" />
        <line x1="35" y1="41" x2="25" y2="42" stroke="#424242" strokeWidth="1" opacity="0.6" />
        <line x1="65" y1="38" x2="75" y2="37" stroke="#424242" strokeWidth="1" opacity="0.6" />
        <line x1="65" y1="41" x2="75" y2="42" stroke="#424242" strokeWidth="1" opacity="0.6" />
        
        {/* Arms/Paws */}
        <ellipse cx="30" cy="55" rx="8" ry="12" fill="url(#logoGradient)" transform="rotate(-20 30 55)" />
        <ellipse cx="70" cy="55" rx="8" ry="12" fill="url(#logoGradient)" transform="rotate(20 70 55)" />
        
        {/* Tool in paw (pencil/paper) */}
        <rect x="66" y="48" width="3" height="12" fill="#fdd835" transform="rotate(25 67 54)" />
        <path d="M 67 48 L 65 45 L 69 45 Z" fill="#ff6b6b" transform="rotate(25 67 46)" />
        
        {/* Sparkles */}
        <circle cx="20" cy="25" r="2" fill="#fdd835" />
        <circle cx="80" cy="30" r="2.5" fill="#fdd835" />
        <circle cx="75" cy="70" r="2" fill="#fdd835" />
      </svg>

      {/* Text */}
      <div>
        <div style={{
          fontSize: `${s.text}px`,
          fontWeight: '700',
          background: 'linear-gradient(135deg, #66bb6a 0%, #42a5f5 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: '1.2'
        }}>
          Teacher Material
        </div>
        {showTagline && (
          <div style={{
            fontSize: `${s.tagline}px`,
            color: '#666',
            fontWeight: '500',
            marginTop: '2px',
            letterSpacing: '0.5px'
          }}>
            Create Materials in Seconds
          </div>
        )}
      </div>
    </div>
  );
}